import React from 'react'
import styles from '../component-styles/loading.module.scss'
import uplifter from '../assets/uplifter-arrow.png'

export default function Loading() {
  return (
    <div className={styles.container}>
      <img src={uplifter} alt="uplifter" className={styles.loader} />
    </div>
  )
}
